export default {
  // Tabs
  'webConfig.tabs.login': 'Cấu hình đăng nhập & đăng ký',
  'webConfig.tabs.thirdParty': 'Cấu hình đăng nhập bên thứ ba',
  'webConfig.tabs.appManage': 'Quản lý ứng dụng',
  'webConfig.tabs.livechat': 'Cài đặt Livechat',
  'webConfig.tabs.otherConfig': 'Cấu hình khác',
  'webConfig.tabs.reportConfig': 'Cấu hình báo cáo giám sát',

  // Cấu hình báo cáo giám sát
  'webConfig.reportConfig.title': 'Cấu hình tỷ lệ báo cáo',
  'webConfig.reportConfig.tip': 'Chỉ áp dụng cho người dùng đăng ký mới; report_status của người dùng hiện có không bị ảnh hưởng. Có hiệu lực ngay sau khi lưu.',
  'webConfig.reportConfig.currentRatio': 'Tỷ lệ hiện tại',
  'webConfig.reportConfig.report': '(Tuyến A)',
  'webConfig.reportConfig.notReport': '(Tuyến B)',
  'webConfig.reportConfig.lastModify': 'Người sửa gần nhất',
  'webConfig.reportConfig.version': 'Phiên bản',
  'webConfig.reportConfig.adjustTo': 'Điều chỉnh thành',
  'webConfig.reportConfig.save': 'Lưu',
  'webConfig.reportConfig.historyTitle': '10 lần thay đổi gần nhất',
  'webConfig.reportConfig.col.version': 'Phiên bản',
  'webConfig.reportConfig.col.time': 'Thời gian',
  'webConfig.reportConfig.col.operator': 'Người thao tác',
  'webConfig.reportConfig.col.change': 'Cũ → Mới',
  'webConfig.reportConfig.col.reason': 'Lý do',
  'webConfig.reportConfig.confirmTitle': 'Xác nhận thay đổi tỷ lệ',
  'webConfig.reportConfig.confirmContent': 'Điều chỉnh tỷ lệ báo cáo thành {{ratio}}%? Có hiệu lực ngay.',
  'webConfig.reportConfig.reasonPh': 'Lý do thay đổi (tùy chọn, phục vụ kiểm toán)',
  'webConfig.reportConfig.saveSuccess': 'Đã lưu',
  'webConfig.reportConfig.saveFail': 'Lưu thất bại',
  'webConfig.reportConfig.fetchError': 'Tải thất bại',
  'webConfig.reportConfig.invalidRatio': 'Vui lòng nhập số nguyên 0~100',

  // Chiến lược tự động nâng tuyến game
  'webConfig.routeStrategy.title': 'Cấu hình chiến lược tuyến game',
  'webConfig.routeStrategy.tip': 'Người dùng mới mặc định tuyến B, khi đạt ngưỡng sẽ nâng một chiều lên tuyến A (không thể đảo ngược). Hai chiến lược có thể đồng thời (đạt bất kỳ điều kiện nào sẽ nâng); hội viên đã chuyển thủ công sẽ không còn chịu tác động của chiến lược tự động.',
  'webConfig.routeStrategy.strategyTitle': 'Bật chiến lược',
  'webConfig.routeStrategy.depositStrategy': 'Theo ngưỡng nạp tích lũy',
  'webConfig.routeStrategy.vipStrategy': 'Theo cấp VIP',
  'webConfig.routeStrategy.vipLevelLabel': 'Cấp VIP nâng hạng',
  'webConfig.routeStrategy.addCurrency': 'Thêm loại tiền',
  'webConfig.routeStrategy.remove': 'Xóa',
  'webConfig.routeStrategy.save': 'Lưu',
  'webConfig.routeStrategy.col.currency': 'Loại tiền',
  'webConfig.routeStrategy.col.amount': 'Ngưỡng',
  'webConfig.routeStrategy.col.enabled': 'Bật',
  'webConfig.routeStrategy.col.action': 'Thao tác',
  'webConfig.routeStrategy.saveSuccess': 'Lưu thành công',
  'webConfig.routeStrategy.saveFail': 'Lưu thất bại',
  'webConfig.routeStrategy.fetchError': 'Tải thất bại',
  'webConfig.routeStrategy.thresholdInvalid': 'Ngưỡng loại tiền được bật cần điền loại tiền và số tiền',
  'webConfig.routeStrategy.currencyDuplicate': 'Loại tiền không được trùng lặp',
  'webConfig.routeStrategy.vipLevelRequired': 'Vui lòng nhập cấp VIP nâng hạng',

  // Login Register Config
  'webConfig.login.inviteCode': 'Mã mời',
  'webConfig.login.inviteCodeRequired': 'Mã mời bắt buộc:',
  'webConfig.login.outletSelection': 'Chọn cửa hàng',
  'webConfig.login.agreementManualCheck': 'Tích chọn điều khoản PAGCOR khi đăng ký',
  'webConfig.login.rgPopupBeforeLogin': 'Popup Responsible Gaming (Trước khi đăng nhập)',
  'webConfig.login.rgPopupAfterLogin': 'Popup Responsible Gaming (Sau khi đăng nhập)',
  'webConfig.login.passwordRisk': 'Kiểm soát rủi ro mật khẩu',
  'webConfig.login.passwordRiskMinutes': 'phút sau',
  'webConfig.login.passwordRiskTimes': 'lần thử thất bại',
  'webConfig.login.identityInfo': 'Thông tin danh tính:',
  'webConfig.login.phoneOtp': 'Xác thực OTP qua điện thoại:',
  'webConfig.login.emailOtp': 'Xác thực OTP qua email:',
  'webConfig.login.isRegKaptcha': 'Chuyển đổi mã xác minh đăng ký:',
  'webConfig.login.isRegisterMobileOTP': 'Công tắc OTP đăng ký:',
  'webConfig.login.isBindBankOTP': 'OTP liên kết tài khoản rút tiền:',
  'webConfig.login.registerCaptcha': 'Loại mã xác thực đăng ký:',
  'webConfig.login.captchaType': 'Loại mã xác thực:',
  'webConfig.login.isLoginKaptcha': 'Chuyển đổi mã xác minh đăng nhập:',
  'webConfig.login.loginCaptcha': 'Loại mã xác thực đăng nhập:',
  'webConfig.login.isForgetPassKaptcha': 'Quên mã xác minh mật khẩu:',
  'webConfig.login.isStrongPassword': 'Chuyển đổi mật khẩu mạnh:',
  'webConfig.login.memberPasswordRule': 'Quy tắc xác minh mật khẩu thành viên:',
  'webConfig.login.isMultipleDeviceLogin': 'Chuyển đổi đăng nhập nhiều thiết bị:',
  'webConfig.login.forgetKaptchaType': 'Quên loại mã xác minh mật khẩu:',
  'webConfig.login.captcha.ziyan': 'Mã xác thực tự phát triển',
  'webConfig.login.captcha.yidun': 'Mã xác thực Yidun',
  'webConfig.login.captcha.cloudfare': 'Mã xác thực cloudfare',
  'webConfig.login.masterCaptcha': 'Công tắc tổng xác thực người-máy:',
  'webConfig.login.masterCaptchaType': 'Loại mã xác thực:',
  'webConfig.login.applicablePages': 'Trang áp dụng:',
  'webConfig.login.configurePages': 'Cấu hình trang áp dụng',
  'webConfig.login.page.login': 'Mã xác thực trang đăng nhập',
  'webConfig.login.page.forgot': 'Mã xác thực quên mật khẩu',
  'webConfig.login.page.register': 'Mã xác thực trang đăng ký',
  'webConfig.login.page.bindPhone': 'Liên kết số điện thoại',
  'webConfig.login.page.bindEmail': 'Liên kết email',
  'webConfig.login.page.bindWithdraw': 'Liên kết tài khoản rút tiền',
  'webConfig.login.page.kioskQuery': 'Tra cứu tài khoản/mật khẩu máy để bàn',
  'webConfig.login.masterCaptchaHint': 'Khi bật, client sẽ kiểm tra xem trang hiện tại có trong danh sách trang áp dụng không. Nếu khớp, cửa sổ xác thực sẽ hiện ra trước khi gửi mã xác minh. Nếu không khớp hoặc công tắc tổng tắt, quy trình gốc sẽ được thực hiện.',
  'webConfig.login.atLeastOnePage': 'Vui lòng chọn ít nhất một trang áp dụng',
  'webConfig.login.noPageConfigured': 'Chưa cấu hình, xác thực sẽ không có hiệu lực',
  'webConfig.login.changePassword': 'Đổi mật khẩu:',
  'webConfig.login.changePassword.phone': 'Xác thực OTP qua điện thoại',
  'webConfig.login.changePassword.email': 'Xác thực OTP qua email',
  'webConfig.login.mobileLoginBg': 'Hình nền đăng nhập di động:',
  'webConfig.login.mobileRegisterBg': 'Hình nền đăng ký di động:',
  'webConfig.login.pcLoginBg': 'Nền đăng nhập PC:',
  'webConfig.login.pcRegisterBg': 'Nền đăng ký PC:',
  'webConfig.login.deviceLimit': 'Giới hạn đăng ký cùng thiết bị (Công tắc):',
  'webConfig.login.deviceLimitTime': 'Thời gian thống kê (Giờ):',
  'webConfig.login.deviceNum': 'Số lượng tài khoản được phép đăng ký:',
  'webConfig.login.ipLimit': 'Giới hạn đăng ký cùng IP (Công tắc):',
  'webConfig.login.ipLimitTime': 'Thời gian thống kê (Giờ):',
  'webConfig.login.ipLimitNum': 'Số lượng tài khoản được phép đăng ký:',
  'webConfig.login.save': 'Lưu',
  'webConfig.login.phoneBind': 'Liên kết số điện thoại',
  'webConfig.login.emailBind': 'Liên kết email',
  'webConfig.login.allowSkip': 'Cho phép bỏ qua',

  // Third Party Config
  'webConfig.thirdParty.google': 'Đăng nhập Google:',
  'webConfig.thirdParty.facebook': 'Đăng nhập Facebook:',
  'webConfig.thirdParty.manualCreate': 'Công tắc xác thực điện thoại đăng nhập bên thứ ba:',
  'webConfig.thirdParty.googleClientId': 'ID khách hàng Google:',
  'webConfig.thirdParty.googleAndroidClientId': 'ID khách hàng ứng dụng Android Google:',
  'webConfig.thirdParty.googleIosClientId': 'ID khách hàng iOS Google:',
  'webConfig.thirdParty.googleLoginUrl': 'URL đăng nhập Google:',
  'webConfig.thirdParty.facebookAppId': 'ID ứng dụng Facebook:',
  'webConfig.thirdParty.facebookAppSecret': 'Mã bí mật ứng dụng Facebook:',
  'webConfig.thirdParty.facebookLoginUrl': 'URL đăng nhập Facebook:',
  'webConfig.thirdParty.appleAppClientId': 'Apple iOS Bundle ID:',

  // App Management
  'webConfig.app.channel': 'Kênh',
  'webConfig.app.appType': 'Loại ứng dụng',
  'webConfig.app.forceUpgrade': 'Bắt buộc cập nhật',
  'webConfig.app.version': 'Phiên bản',
  'webConfig.app.downloadUrl': 'URL tải xuống',
  'webConfig.app.status': 'Trạng thái',
  'webConfig.app.status.enabled': 'Đã bật',
  'webConfig.app.status.disabled': 'Đã tắt',
  'webConfig.app.actions': 'Thao tác',
  'webConfig.app.edit': 'Chỉnh sửa',
  'webConfig.app.delete': 'Xóa',
  'webConfig.app.disable': 'Tắt',
  'webConfig.app.enable': 'Bật',
  'webConfig.app.editTitle': 'Chỉnh sửa cấu hình ứng dụng',
  'webConfig.app.downloadSettings': 'Cài đặt tải xuống ứng dụng',
  'webConfig.app.cancel': 'Hủy',
  'webConfig.app.confirm': 'Xác nhận',

  // Livechat Config
  'webConfig.livechat.clientId': 'ID khách hàng LiveChat:',
  'webConfig.livechat.grantType': 'Loại cấp phép LiveChat:',
  'webConfig.livechat.licenseId': 'ID giấy phép LiveChat:',
  'webConfig.livechat.responseType': 'Loại phản hồi LiveChat:',
  'webConfig.livechat.redirectUrl': 'URL chuyển hướng LiveChat:',
  'webConfig.livechat.backupUrl': 'URL dự phòng dịch vụ khách hàng:',

  // SEO - Google Search Console
  'webConfig.tabs.gsc': 'Google Search Console (Thống kê lập chỉ mục SEO)',
  'webConfig.gsc.siteUrl': 'Thuộc tính trang GSC:',
  'webConfig.gsc.siteUrlDesc': 'Định danh tài nguyên trong Search Console, ví dụ sc-domain:example.com hoặc https://example.com/',
  'webConfig.gsc.siteBaseUrl': 'URL gốc trang SEO:',
  'webConfig.gsc.siteBaseUrlDesc': 'Origin nơi các trang bài viết thực sự tồn tại, dùng để tạo URL tuyệt đối cho sitemap và kiểm tra lập chỉ mục. Bắt buộc khi tài nguyên GSC ở trên là tên miền (vd sc-domain:example.com) nhưng bài viết nằm ở subdomain (vd https://www.example.com). Để trống sẽ dùng "Thuộc tính trang GSC".',
  'webConfig.gsc.serviceAccountJson': 'JSON tài khoản dịch vụ GSC:',
  'webConfig.gsc.serviceAccountJsonPlaceholder': 'Dán nguyên vẹn toàn bộ file .json tài khoản dịch vụ tải từ Google Cloud (không sửa tay). Ví dụ: { "type": "service_account", "project_id": "...", "private_key": "...", "client_email": "xxx@xxx.iam.gserviceaccount.com", ... }',
  'webConfig.gsc.serviceAccountJsonDesc': 'Dán toàn bộ JSON khóa tài khoản dịch vụ Google. Tài khoản dịch vụ phải được thêm làm người dùng của tài nguyên này trong Search Console. Để trống thì "Đã lập chỉ mục / Loại trừ" sẽ hiển thị "-".',
  'webConfig.gsc.syncBatchSize': 'Số trang mỗi lần đồng bộ:',
  'webConfig.gsc.syncBatchSizeDesc': 'Số trang tối đa mỗi lần tác vụ kiểm tra (luân phiên tăng dần, ưu tiên trang lâu chưa đồng bộ). Giới hạn bởi hạn mức GSC (2000/ngày): giá trị này × số lần chạy/ngày nên ≤ 2000. Nếu chạy mỗi 15 phút (96 lần/ngày), nên ≤ 20. Để trống = mặc định 20; 0 = tất cả trang (thận trọng).',

  // Other Config
  'webConfig.other.pointExpire': 'Thời hạn điểm:',
  'webConfig.other.adminGoogleAuth': 'Xác thực Google quản trị:',
  'webConfig.other.kycProcess': 'Quy trình xác minh KYC:',
  'webConfig.other.kycAutoApprove': 'Tự động phê duyệt KYC:',
  'webConfig.other.kycRegisterWithdraw': 'KYC rút tiền:',
  'webConfig.other.KycAgent': 'Đại lý bỏ qua KYC đăng ký:',
  'webConfig.other.isOpenBlackList': 'Kiểm tra KYC trong Danh sách đen:',
  'webConfig.other.kycWithDrawAgent': 'Đại lý bỏ qua KYC rút tiền:',
  'webConfig.other.KycSimplify': 'KYC đăng ký:',
  'webConfig.other.kycRegisterForce': 'Đăng ký chứng nhận KYC bắt buộc:',
  'webConfig.other.KycInterceptorsPath': 'Đường dẫn chặn KYC:',
  'webConfig.other.withdrawKYCVerifyDateNum': 'Thời hạn hiệu lực của lỗi KYC rút tiền:',
  'webConfig.other.withdrawKYCVerifyTimes': 'Số lần nhắc nhở KYC rút tiền:',
  'webConfig.other.withdrawKYCInterceptorsPath': 'Đường dẫn chặn lỗi KYC rút tiền:',
  'webConfig.other.adminLogo': 'URL logo quản trị:',
  'webConfig.other.vapeSafeMode': 'Chế độ an toàn Vape:',
  'webConfig.other.imageUrl': 'URL truy cập hình ảnh:',
  'webConfig.other.gameImageUrl': 'URL truy cập hình ảnh trò chơi:',
  'webConfig.other.payCallbackDomain': 'Tên miền gọi lại thanh toán:',
  'webConfig.other.allowedCountries': 'Quốc gia được phép truy cập frontend:',
  'webConfig.other.vipMaxLevel': 'Hiển thị cấp VIP tối đa',
  'webConfig.other.vipRewardWeeklyPayoutDay': 'Ngày trả lương hàng tuần của VIP',
  'webConfig.other.vipRewardWeeklyPayoutDayDesc': 'Hỗ trợ các số từ 1-7 (Thứ Hai = 1), Tiếng Anh THỨ HAI..CHỦ NHẬT',
  'webConfig.other.vipRewardWeeklyWindowDays': 'Thống kê lương tuần của VIP ngày',
  'webConfig.other.vipMaxLevelDesc': 'Kiểm soát số cấp VIP hiển thị ở giao diện người dùng. Vui lòng đảm bảo giá trị tăng trưởng của cấp được đặt là vô hạn.',
  'webConfig.other.rtpRange': 'Phạm vi hiển thị RTP',
  'webConfig.other.appDownloadLandingPage': 'URL trang đích tải xuống ứng dụng:',
  'webConfig.other.appAndroidDownloadLandingPage': 'URL trang đích tải xuống ứng dụng Android:',
  'webConfig.other.appAndroidVersion': 'Số phiên bản ứng dụng Android:',
  'webConfig.other.appAndroidForceUpdate': 'Cập nhật bắt buộc ứng dụng Android:',
  'webConfig.other.activeUserAgent': 'Đại lý người dùng hoạt động:',
  'webConfig.other.activeUserAgentPlaceholder': 'Vui lòng chọn đại lý người dùng hoạt động',
  'webConfig.other.indexLoading': 'Hoạt ảnh khởi động:',
  'webConfig.other.balanceLimit.title': 'Thông tin tài khoản - Điều chỉnh thủ công',
  'webConfig.other.balanceLimit.addMax': 'Giới hạn số tiền tăng:',
  'webConfig.other.balanceLimit.addMaxPlaceholder': 'Vui lòng nhập giới hạn số tiền tăng',
  'webConfig.other.balanceLimit.reduceMax': 'Giới hạn số tiền giảm:',
  'webConfig.other.balanceLimit.reduceMaxPlaceholder': 'Vui lòng nhập giới hạn số tiền giảm',
  'webConfig.other.balanceLimit.numberRule': 'Vui lòng nhập số lớn hơn 1',
  'webConfig.other.nonNegativeNumberRule': 'Vui lòng nhập số lớn hơn hoặc bằng 0',
  'webConfig.other.pointLimit.title': 'Điểm thành viên - Điều chỉnh điểm thủ công',
  'webConfig.other.pointLimit.addMax': 'Giới hạn điểm thành viên tăng:',
  'webConfig.other.pointLimit.addMaxPlaceholder': 'Vui lòng nhập giới hạn điểm thành viên tăng',
  'webConfig.other.pointLimit.reduceMax': 'Giới hạn điểm thành viên giảm:',
  'webConfig.other.pointLimit.reduceMaxPlaceholder': 'Vui lòng nhập giới hạn điểm thành viên giảm',
  'webConfig.other.pointLimit.numberRule': 'Vui lòng nhập số lớn hơn 1',
  'webConfig.other.opUserAgentAllocLimit.title': 'Tài khoản hậu đài → Đại lý: Giới hạn phân bổ mỗi lần',
  'webConfig.other.opUserAgentAllocLimit.desc': 'Kiểm soát giới hạn mỗi lần tài khoản hậu đài phân bổ hạn mức cho đại lý cấp 1 hoặc cấp 2 (PHP / VND / CNY độc lập)',
  'webConfig.other.opUserAgentAllocLimit.addMax': 'Giới hạn tăng hạn mức mỗi lần:',
  'webConfig.other.opUserAgentAllocLimit.addMaxPlaceholder': 'Vui lòng nhập giới hạn tăng hạn mức mỗi lần',
  'webConfig.other.opUserAgentAllocLimit.reduceMax': 'Giới hạn giảm hạn mức mỗi lần:',
  'webConfig.other.opUserAgentAllocLimit.reduceMaxPlaceholder': 'Vui lòng nhập giới hạn giảm hạn mức mỗi lần',
  'webConfig.other.agentAllocLimit.title': 'Giới hạn phân bổ đại lý',
  'webConfig.other.agentAllocLimit.desc': 'Kiểm soát giới hạn mỗi lần đại lý cấp 1 (L1) phân bổ hạn mức cho đại lý cấp 2 (L2) (chỉ áp dụng cho mục tiêu "Hạn mức điều chỉnh")',
  'webConfig.other.agentAllocLimit.addMax': 'Giới hạn tăng hạn mức mỗi lần:',
  'webConfig.other.agentAllocLimit.addMaxPlaceholder': 'Vui lòng nhập giới hạn tăng hạn mức mỗi lần',
  'webConfig.other.agentAllocLimit.reduceMax': 'Giới hạn giảm hạn mức mỗi lần:',
  'webConfig.other.agentAllocLimit.reduceMaxPlaceholder': 'Vui lòng nhập giới hạn giảm hạn mức mỗi lần',

  // Common
  'webConfig.common.yes': 'Có',
  'webConfig.common.no': 'Không',
  'webConfig.common.saveSuccess': 'Lưu thành công',
  'webConfig.common.saveFailed': 'Lưu thất bại',
  'webConfig.common.updateSuccess': 'Cập nhật thành công',
  'webConfig.common.updateFailed': 'Cập nhật thất bại',
  'webConfig.common.disableSuccess': 'Tắt thành công',
  'webConfig.common.disableFailed': 'Tắt thất bại',
  'webConfig.common.enableSuccess': 'Bật thành công',
  'webConfig.common.enableFailed': 'Bật thất bại',
  'webConfig.common.deleteSuccess': 'Xóa thành công',
  'webConfig.common.deleteFailed': 'Xóa thất bại',
  'sys.enterCorrectEmail': 'Vui lòng nhập địa chỉ email hợp lệ',

  // Nhãn mục từ điển: key = dict.<groupCode>.<itemCode> (mã trung tính ngôn ngữ từ dict_group_item).
  // Dùng chung cho nhiều module. Không hiển thị trực tiếp item_name / item_name_en từ backend.
  // 21005 loại ứng dụng
  'dict.21005.21005001': 'iOS',
  'dict.21005.21005002': 'Android',
  // 21006 kênh ứng dụng
  'dict.21006.21006001': 'Super Sign',
  'dict.21006.21006002': 'App Store',
  'dict.21006.21006003': 'Google Play',
  'dict.21006.21006004': 'Cửa hàng XIAOMI',
  'dict.21006.21006005': 'Cửa hàng CHUANYIN',
  'dict.21006.21006006': 'VIVO',
  'dict.21006.21006007': 'OPPO',
  'dict.21006.21006008': 'Huawei',
  // 80002 loại email / định dạng email
  'dict.80002.80002001': 'Email Microsoft',
  'dict.80002.80002002': 'Email Google',
  'dict.80002.80002003': 'mailgun',
  // 80003 loại nghiệp vụ email
  'dict.80003.80003001': 'Gửi mã xác minh',
};
